import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/img/logo-white.svg";
import {
	Discord,
	Metaverse,
	Telegram,
	TelegramAnnouncement,
	Twitter,
} from "../assets/ThemeIcon";
import FooterMobile from "./shapes/FooterMobile";
import FooterShape from "./shapes/FooterShape";

const data = [
	{
		name: "Projects",
		link: "/projects",
	},
	{
		name: "Terms of Service",
		link: "/projects",
	},
	{
		name: "Audits",
		link: "/projects",
	},
	{
		name: "Staking",
		link: "/projects",
	},
	{
		name: "Privacy Policy",
		link: "/projects",
	},
];
const data2 = [
	{
		name: "Projects",
		link: "/projects",
	},
	{
		name: "Terms of Service",
		link: "/projects",
	},
	{
		name: "Staking",
		link: "/projects",
	},
	{
		name: "Privacy Policy",
		link: "/projects",
	},
	{
		name: "Audits",
		link: "/projects",
	},
];
const social = [
	{
		link: "https://twitter.com/yieldlyfinance",
		icon: <Twitter />,
	},
	{
		link: "https://discord.gg/Vxdw7t5ZaX",
		icon: <Discord />,
	},
	{
		link: "https://t.me/+okf36R3EYtYzMWE0",
		icon: <Telegram />,
	},
	{
		link: "https://t.me/yLaunchAnnouncements",
		icon: <TelegramAnnouncement />,
	},
	{
		link: "https://yieldly.medium.com/",
		icon: <Metaverse />,
	},
];
const Footer = () => {
	const [mobileScreen, setMobileScreen] = useState(true);

	const handleMobile = () => {
		const width = window.innerWidth;
		if (width < 767) {
			setMobileScreen(true);
		} else {
			setMobileScreen(false);
		}
	};

	useEffect(() => {
		handleMobile();
		window.addEventListener("resize", handleMobile);
	}, []);
	return (
		<footer>
			<div className="footer-shape">
				{mobileScreen ? <FooterMobile /> : <FooterShape />}
			</div>
			<div className="footer-top">
				<div className="container">
					<div className="footer-wrapper">
						<div className="footer-wrapper-left">
							<Link to="/" className="logo">
								<img src={logo} alt="" />
							</Link>
							<div className="slogan">
								Built on Algorand, Powered by you.
							</div>
						</div>
						<div className="footer-wrapper-right">
							<ul className="links">
								{mobileScreen
									? data &&
									  data.map(({ link, name }, i) => (
											<li key={i}>
												<Link to={link}>{name}</Link>
											</li>
									  ))
									: data2 &&
									  data2.map(({ link, name }, i) => (
											<li key={i}>
												<Link to={link}>{name}</Link>
											</li>
									  ))}
							</ul>
							<ul className="social-icons">
								{social &&
									social.map(({ link, icon }, i) => (
										<li key={i}>
											<a
												href={link}
												target="_blank"
												rel="noreferrer"
											>
												{icon}
											</a>
										</li>
									))}
							</ul>
						</div>
					</div>
				</div>
			</div>
			<div className="footer-bottom">
				<div className="container">
					Copyright &copy; 2022 <Link to="#">yLaunch</Link>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
